import React from "react"
import { Paper, Title } from "@mantine/core"
import { LANDING_COPY } from "../../../docs/catalog"
import type { FrameworkCapabilities } from "../../../docs/types"

// A framework page's "How it runs" list (contract v9): the row's capability
// record — what it is tested on, its databases, where the secrets live, what
// a refund can do and what a mobile app may assume — in the layout of a
// platform page's list. The labels are config/landing_copy.json's, in its
// order; the sentences are the contract's, shown as given.
export const CapabilityFacts: React.FC<{ capabilities: FrameworkCapabilities | null }> = ({ capabilities }) => {
  if (!capabilities) return null
  const copy = LANDING_COPY.integrations.capabilities
  return (
    <Paper className="or-platform-facts" radius="lg" p={{ base: "md", sm: "xl" }} withBorder>
      <Title order={2} className="or-quicksetup-title">
        {copy.title}
      </Title>
      <dl className="or-platform-facts-list">
        {Object.entries(copy.labels).map(([field, label]) => (
          <div key={field} className="or-platform-fact">
            <dt>{label}</dt>
            <dd>{capabilities[field as keyof FrameworkCapabilities]}</dd>
          </div>
        ))}
      </dl>
    </Paper>
  )
}
